// @ts-nocheck
/* eslint-disable */
export const outlineArrowNarrowRightIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 12"><path fill="currentColor" fill-rule="evenodd" d="M6.735 2.735a.375.375 0 0 1 .53 0l3 3a.375.375 0 0 1 0 .53l-3 3a.375.375 0 1 1-.53-.53l2.36-2.36H2a.375.375 0 1 1 0-.75h7.095l-2.36-2.36a.375.375 0 0 1 0-.53" clip-rule="evenodd"/></svg>`,
    name: 'outline-arrow-narrow-right' as const
};